<template>
	<div>
		<pui-datatable
			:modelName="model"
			:modelColumnDefs="columnDefs"
			:navigableDetail="false"
			:actions="actions"
			:showSearcher="false"
		></pui-datatable>
		<notificationexhibitorproductmodals :modelName="model"></notificationexhibitorproductmodals>
	</div>
</template>

<script>
import InterestExhibitorProductActions from './InterestExhibitorProductActions.js';
import NotificationExhibitorProductModals from './InterestExhibitorProductModals';

export default {
	name: 'interestexhibitorproductsgrid',
	components: {
		notificationexhibitorproductmodals: NotificationExhibitorProductModals
	},
	data() {
		return {
			model: 'interestexhibitorproduct',
			actions: InterestExhibitorProductActions.actions,
			columnDefs: {
				inteorigininterest: {
					render: (data) => {
						if (data === 'S') {
							return this.printS;
						} else if (data === 'C') {
							return this.printC;
						}
						return data;
					}
				}
			}
		};
	},

	computed: {
		printS() {
			return this.$t('interestOrigin.S');
		},
		printC() {
			return this.$t('interestOrigin.C');
		}
	}
};
</script>

<style lang="postcss" scoped></style>
